module.exports = __webpack_public_path__ + "media/C.a42e0e5e.mp3";